<template>
  <td :class="{ reduced: isHidden, [field + '-column']: true }">
    <slot v-if="!isHidden"></slot>
    <span v-else>-</span>
  </td>
</template>

<script>
import { CustomTableService } from "@/services/CustomTableService";

export default {
  props: ['field'],
  inject: ["tableId"],

  computed: {
    isHidden() {
      return CustomTableService.data
          .get(this.tableId)
          .fields.hiddenField?.[this.field];
    },
  }
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl'

td
  min-width 0
  width auto

.reduced
  width 20px
  text-align center
</style>